import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import NavBar from "../../components/navbar/navbar.component";
import SideBar from "../../components/sidebar/sidebar.component";
import { getShipments, removeShipment } from "../../state/actions";

const ShipmentImportSummary = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const isLoading = useSelector((state) => state.orders.status);
  const [shipments, setShipments] = useState([]);
  const importDetails = location.state?.importDetails;

  useEffect(() => {
    if (!importDetails) {
      return;
    }

    dispatch(getShipments(importDetails)).then((response) => {
      setShipments(response?.shipments || []);
    });
  }, [dispatch, importDetails]);

  const handleRemoveShipment = async (shipment) => {
    const shouldRemove = window.confirm(
      `Are you sure you want to remove shipment ${shipment.waybillNumber}?`
    );

    if (!shouldRemove) {
      return;
    }

    try {
      const wasRemoved = await dispatch(removeShipment(shipment.waybillNumber));

      if (!wasRemoved) {
        alert("Unable to remove shipment");
        return;
      }

      setShipments((currentShipments) =>
        currentShipments.filter((currentShipment) => currentShipment.id !== shipment.id)
      );
      alert("Shipment removed successfully");
    } catch (error) {
      console.log("Unable to remove shipment", error);
      alert("Unable to remove shipment");
    }
  };

  return (
    <>
      <NavBar />
      <SideBar />

      <div className="content-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">Imported Shipments</h4>
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={() => navigate("/daily-shipments")}
                  >
                    Back to Daily Shipments
                  </button>
                </div>
                <div className="card-body">
                  {isLoading === "loading" ? (
                    <div className="text-center mt-4">
                      <div className="spinner-border text-danger" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <p className="small">Fetching Shipments...</p>
                    </div>
                  ) : !importDetails ? (
                    <div className="text-center mx-auto mt-4">
                      <p className="text-Center">
                        Import a shipment from Daily Shipments to view its summary.
                      </p>
                    </div>
                  ) : shipments.length > 0 ? (
                    <div className="table-responsive">
                      <Table aria-label="imported shipments table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Order Number</TableCell>
                            <TableCell>Pickup</TableCell>
                            <TableCell>Origin</TableCell>
                            <TableCell>Destination</TableCell>
                            <TableCell>Content</TableCell>
                            <TableCell>Weight</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {shipments.map((shipment) => (
                            <TableRow hover tabIndex={-1} key={shipment.id}>
                              <TableCell>{shipment.waybillNumber}</TableCell>
                              <TableCell>{shipment.senderAddress}</TableCell>
                              <TableCell>{shipment.origin?.name}</TableCell>
                              <TableCell>{shipment.city?.name}</TableCell>
                              <TableCell>{shipment.contentDescription}</TableCell>
                              <TableCell>{`${shipment.weight}kg`}</TableCell>
                              <TableCell>{shipment.unit}</TableCell>
                              <TableCell style={{ whiteSpace: "nowrap" }}>
                                <button
                                  className="btn btn-sm btn-primary mr-1"
                                  onClick={() => handleRemoveShipment(shipment)}
                                >
                                  Remove
                                </button>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  ) : (
                    <div className="text-center mx-auto mt-4">
                      <p className="text-Center">No Shipment Available Currently</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShipmentImportSummary;
